import { getFontStyles } from '@ycos/primitives'
import napStyles from './../napRtl.json'

export default {
  ...getFontStyles(napStyles, { type: 'Heading', name: 'A1' }),
  color: napStyles.colors.PrimaryBlack,
  lineColor: napStyles.colors.SecondaryGreySteel,
  fontWeight: 'normal',
  loyaltyFontStyle: {
    fontFamily: 'AkkuratProArabic, sans-serif',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '24px'
  }
}
